/**
 * Plataforma a la que aplica un banner. Mismo vocabulario que las difusiones
 * push (`PushBroadcast`): `sellers` = cuentas con rol SELLER, `buyers` = cuentas
 * con rol USER (quien tiene ambos entra en las dos), `all` = ambas plataformas.
 */
export type BannerAudience = 'all' | 'sellers' | 'buyers';

export const BANNER_AUDIENCE_OPTIONS: { value: BannerAudience; label: string }[] = [
  { value: 'all', label: 'Ambas plataformas' },
  { value: 'sellers', label: 'Vendedores' },
  { value: 'buyers', label: 'Compradores' },
];

/** Banner del home (imagen en Spaces, con ventana de programación — spec 9.1). */
export interface Banner {
  id: number;
  title?: string;
  imageUrl?: string;
  url?: string;
  image?: string;
  linkUrl?: string;
  audience?: BannerAudience;
  position?: number;
  sortOrder?: number;
  startsAt?: string | null;
  starts_at?: string | null;
  endsAt?: string | null;
  ends_at?: string | null;
  createdAt?: string;
  [key: string]: unknown;
}
